import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import logo from "../../images/dpdLogoBlue.png";
import driver from "../../images/driverBlue.jpg";
import spinner from "../../images/dpdSpinnerBlue.gif";
import collectFromDepot from "../../images/CollectFromDepotBlue.jpg";
import driverBgBanner from "../../images/DriverProfileBlue.jpg";
import collectFromDepotMobile from "../../images/MobileBackgrounds/CollectFromDepotBlue.png";
import driverBgBannerMobile from "../../images/MobileBackgrounds/BlueDriver.png";
export const images = {
  logo,
  driver,
  spinner,
  parcelLogo: logo,
  collectFromDepot,
  driverBgBanner,
  collectFromDepotMobile,
  driverBgBannerMobile
};
export default {
  dpdSiteUrl: "https://www.dpdlocal.co.uk",
  palette: {
    primary: {
      main: "#009adf",
      contrastText: "#fff"
    }
  }
};